import { Input } from "@tql/ui-components-react/kendo/inputs";
import { Label } from "@tql/ui-components-react/kendo/labels";
import { useState } from "react";
import { flushSync } from "react-dom";

export const NameField = ({
	initialValue,
	onClearError,
	onCommit,
	showError,
}: {
	initialValue: string;
	onClearError: () => void;
	onCommit: (value: string) => void;
	showError: boolean;
}) => {
	const [localValue, setLocalValue] = useState(initialValue);

	return (
		<div>
			<Label>Routing Guide Name:</Label>
			<div
				style={
					showError
						? {
								outline: "2px solid var(--kendo-color-error)",
								borderRadius: "2px",
							}
						: undefined
				}
			>
				<Input
					data-testid={"routing-guide-name-input"}
					onBlur={() => {
						if (localValue !== initialValue) {
							// flushSync so any subsequent click on a Save button reads the
							// committed name from parent state, not the stale closure.
							flushSync(() => {
								onCommit(localValue);
							});
						}
					}}
					onChange={(e) => {
						if (typeof e.target.value === "string") {
							const next = e.target.value;
							setLocalValue(next);
							// Optimistically clear the activation error as soon as the
							// user types something. setShowNameError(false) is a no-op
							// when already false, so this triggers at most one parent
							// re-render after a failed save.
							if (showError && next.trim()) {
								onClearError();
							}
						}
					}}
					value={localValue}
				/>
			</div>
			{showError ? (
				<span
					style={{
						color: "var(--kendo-color-error)",
						display: "block",
						fontSize: "11px",
						marginTop: "2px",
					}}
				>
					A value must be input in order to activate
				</span>
			) : null}
		</div>
	);
};
